import styled from 'styled-components';

export const Button = styled.button`
	position: relative;
	margin-right: 70px;
	float: right;
	margin-top: -60px;
	height: 2.5rem;
	padding: 5px 30px;
	font-size: 24px;
	font-family: monospace;
	text-align: center;
	outline: none;
	color: #fff;
	background-color: #2a91a3;
	border: none;
	border-radius: 15px;
	box-shadow: 0 5px #999;
	&:hover {
		background-color: #437e4a;
	}
	&:active {
		background-color: #e61313;
		box-shadow: 0 5px #666;
		transform: translateY(4px);
	}
	@media (max-width: 600px) {
		padding: 2px 9px;
		bottom: 0;
		margin-bottom: 90px;
		margin-left: 40%;
		position: absolute;
	}
`;
